import styled from "@emotion/styled";
import { Tab, Tabs } from "@mui/material";

export const StyledTabs = styled(Tabs)`
  background-color: #091d35;
  @media (max-width: 639px) {
    align-items: center;
    background-color: #091d35;

    & .MuiTabs-scroller {
      background-color: #091d35 !important;
      border-radius: 1.5px;
    }
    & .MuiTabs-indicator {
      display: none !important;
    }
  }
`;

export const StyledTab = styled(Tab)`
  margin-right: 0 !important;
  margin-right: 0 !important;
  font-weight: 400;
  font-size: 18px;

  color: ${({ theme }) => theme.palette.grey.g4};
  background-color: #091d35;
  /* border-radius: 0px; */
  @media (max-width: 639px) {
    border-right: 1px solid;
    border-color: ${({ theme }) => theme.palette.grey.g4} !important;
    border-radius: 0;
  }
  @media (min-width: 640px) {
    margin-bottom: 16px;
    padding: 8px;
    align-items: flex-start;
    background-color: #091d35;
  }
  @media (min-width: 768px) {
    border-radius: 16px;
    width: 290px;
  }
  &.Mui-selected {
    /* background-color: ${({ theme }) => theme.palette.primary.main}; */
    /* border-radius: 12px; */
    color: #00ffcb;
  }
`;
